import React, { Component } from 'react';
import { connect } from 'react-redux'
import { getPresentation, clearPresentation, getSessions } from './actions';
import Spiner from '../helpers/Spiner/Spiner';
import './style.scss'
import Sliders from './components/Sliders';
import Slide from './components/Slide';

class Presentation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      session_id: 0,
      imgs_loaded: true,
    }
  }
  
  async componentDidMount(){
    await this.props.getPresentation(this.props.match.params.id, 0);
    await this.props.getSessions(this.props.match.params.id);
    this.setState({loaded: true})
  }

  componentWillUnmount(){
    this.props.clearPresentation()
  }

  loadFileSpiner = (status) => {
    this.setState({imgs_loaded: status})
  }

  onChangeSessionId = async (session_id) => {
    this.setState({loaded: false});
    await this.props.getPresentation(this.props.match.params.id, session_id);
    this.setState({loaded: true, session_id});
  }

  render() {
    const {loaded, session_id, imgs_loaded} = this.state;
    const {data_loaded, loaded_imgs} = this.props;
    console.log("Presentation -> render -> data_loaded", data_loaded)
    if(!loaded) {
      return <Spiner />
    }
    return (
      <div className="qbm-content Presentation row">
        {(!data_loaded || !imgs_loaded || !loaded_imgs) && <div style={{display: 'flex', position: 'absolute', zIndex: 999, width: '100%', height: 'calc(100% - 50px)', background: 'rgba(255, 255, 255, 0.4)'}}>
          <Spiner />
        </div>}
        <Sliders onChangeSession={this.onChangeSessionId} loadFileSpiner={this.loadFileSpiner} session_id={session_id} />
        <Slide session_id={session_id} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  data_loaded: state.presentation.loaded,
  loaded_imgs: state.presentation.loaded_imgs,
})

const mapDispatchToProps = {
  getPresentation,
  clearPresentation,
  getSessions,
}

export default connect(mapStateToProps, mapDispatchToProps)(Presentation)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentation/index.jsx